import { EventEmitter, Injectable, Output } from '@angular/core';
import { InputField } from '../../model';
import { HeaderEditorStoreService } from '../header-editor/header-editor-store.service';
import { HeaderConfig } from '@urbannex/storethemes';

@Injectable({
  providedIn: 'root'
})
export class FieldUpdaterService {

  @Output() trackUpdatedField = new EventEmitter<InputField>();

  constructor(private headerStore:HeaderEditorStoreService) { }

  updateField(section:String,key:string,field:InputField):void{
    switch (section) {
      case "header":
        this.updateHeaderField(key,field)        
        break;
    
      default:
        break;
    }
  }

  updateHeaderField(key:string,field:InputField){
    switch (key) {
      case "mainDark":
        this.headerStore.updateHeaderTheme(field);
        break;
      case "custom":
        console.log({Custom:field});

        this.headerStore.updateHeaderCustom(field)
        this.trackUpdatedField.emit(field);
        break;
      case "background":
        this.headerStore.updateHeaderBackground(field);
        break;
      case "color":
        this.headerStore.updateHeaderColor(field);
      default:
        break;
    }
  }

}
